// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2023 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import request from '@/utils/request';

/**
 * 优惠券 添加
 * @param pram
 */
export function platformCouponAddApi(data) {
  return request({
    url: '/admin/platform/coupon/add',
    method: 'post',
    data: data
  });
}

/**
 * 优惠券 列表
 * @param pram
 */
export function platformCouponListApi(params) {
  return request({
    url: '/admin/platform/coupon/list',
    method: 'get',
    params: params
  });
}

/**
 * 用户管理 发送优惠券
 * @param pram
 */
export function couponSendApi(data) {
  return request({
    url: '/admin/platform/coupon/batch/send',
    method: 'post',
    data: data
  });
}

/**
 * 优惠券 可发送优惠券列表
 * @param pram
 */
export function canSendListApi(params) {
  return request({
    url: '/admin/platform/coupon/can/send/list',
    method: 'get',
    params: params
  });
}

/**
 * 优惠券 详情
 * @param pram
 */
export function couponInfoApi(id) {
  return request({
    url: "/admin/platform/coupon/detail/".concat(id),
    method: 'get'
  });
}

/**
 * 优惠券 修改状态
 * @param pram
 */
export function couponStatusApi(id) {
  return request({
    url: "/admin/platform/coupon/switch/".concat(id),
    method: 'post'
  });
}

/**
 * 优惠券 删除
 * @param pram
 */
export function couponDeleteApi(data) {
  return request({
    url: '/admin/platform/coupon/delete',
    method: 'post',
    data: data
  });
}

/**
 * 优惠券 优惠券记录列表
 * @param pram
 */
export function couponUserListApi(params) {
  return request({
    url: '/admin/platform/coupon/user/list',
    method: 'get',
    params: params
  });
}

/**
 * 优惠券 编辑
 * @param pram
 */
export function platformCouponEditApi(data) {
  return request({
    url: '/admin/platform/coupon/update',
    method: 'post',
    data: data
  });
}

/**
 * 新人礼 获取
 * @param pram
 */
export function newPeoplePresentConfigApi() {
  return request({
    url: '/admin/platform/marketing/activity/new/people/present/config',
    method: 'get'
  });
}

/**
 * 生日礼 获取
 * @param pram
 */
export function birthdayPresentConfigApi() {
  return request({
    url: '/admin/platform/marketing/activity/birthday/present/config',
    method: 'get'
  });
}

/**
 * 新人礼 编辑
 * @param pram
 */
export function newPeoplePresentEditApi(data) {
  return request({
    url: '/admin/platform/marketing/activity/new/people/present/edit',
    method: 'post',
    data: data
  });
}

/**
 * 生日礼 编辑
 * @param pram
 */
export function birthdayPresentEditApi(data) {
  return request({
    url: '/admin/platform/marketing/activity/birthday/present/edit',
    method: 'post',
    data: data
  });
}

/**
 * 积分日志 列表
 * @param pram
 */
export function integralListApi(params, data) {
  return request({
    url: '/admin/platform/integral/list',
    method: 'get',
    params: params,
    data: data
  });
}

/**
 * 签到 基础签到配置
 */
export function signBaseConfigApi(data) {
  return request({
    url: "/admin/platform/sign/edit/base/config",
    method: 'post',
    data: data
  });
}

/**
 * 签到 新增连续签到配置
 */
export function signAddConfigApi(data) {
  return request({
    url: "/admin/platform/sign/add/config",
    method: 'post',
    data: data
  });
}

/**
 * 签到 编辑连续签到配置
 */
export function signeEditConfigApi(data) {
  return request({
    url: "/admin/platform/sign/edit/award/config",
    method: 'post',
    data: data
  });
}

/**
 * 签到 删除连续签到配置
 */
export function signeDelConfigApi(id) {
  return request({
    url: "/admin/platform/sign/delete/config/".concat(id),
    method: 'post'
  });
}

/**
 * 签到 获取签到配置
 */
export function signeGetConfigApi() {
  return request({
    url: "/admin/platform/sign/get/config",
    method: 'get'
  });
}

/**
 * 签到 用户签到记录分页列表
 */
export function signeRecordListApi() {
  return request({
    url: "/admin/platform/sign/user/record/list",
    method: 'get'
  });
}

/**
 * 秒杀 秒杀时段列表
 */
export function seckillIntervalListApi(params) {
  return request({
    url: "/admin/platform/seckill/time/interval/list",
    method: 'get',
    params: params
  });
}

/**
 * 秒杀 新增秒杀时段
 */
export function seckillIntervalAddApi(data) {
  return request({
    url: "/admin/platform/seckill/time/interval/add",
    method: 'POST',
    data: data
  });
}

/**
 * 秒杀 编辑秒杀时段
 */
export function seckillIntervalUpdateApi(data) {
  return request({
    url: "/admin/platform/seckill/time/interval/update",
    method: 'POST',
    data: data
  });
}

/**
 * 秒杀 删除秒杀时段
 */
export function seckillIntervalDeleteApi(id) {
  return request({
    url: "admin/platform/seckill/time/interval/delete/".concat(id),
    method: 'POST'
  });
}

/**
 * 秒杀 秒杀时段开关
 */
export function seckillIntervalSwitcheApi(id) {
  return request({
    url: "admin/platform/seckill/time/interval/switch/".concat(id),
    method: 'POST'
  });
}

/**
 * 秒杀 新增秒杀活动
 */
export function seckillActivityAddApi(data) {
  return request({
    url: "/admin/platform/seckill/activity/add",
    method: 'POST',
    data: data
  });
}

/**
 * 秒杀 秒杀活动详情
 */
export function seckillActivityDetailApi(id) {
  return request({
    url: "/admin/platform/seckill/activity/detail/".concat(id),
    method: 'get'
  });
}

/**
 * 秒杀 秒杀活动分页列表
 */
export function seckillActivityListApi(params) {
  return request({
    url: "/admin/platform/seckill/activity/page",
    method: 'get',
    params: params
  });
}

/**
 * 秒杀 删除秒杀活动
 */
export function seckillAtivityDelApi(id) {
  return request({
    url: "/admin/platform/seckill/activity/delete/".concat(id),
    method: 'POST'
  });
}

/**
 * 秒杀 编辑秒杀活动
 */
export function seckillAtivityUpdateApi(data) {
  return request({
    url: "/admin/platform/seckill/activity/update",
    method: 'POST',
    data: data
  });
}

/**
 * 秒杀 秒杀活动开关
 */
export function seckillAtivitySwitchApi(id) {
  return request({
    url: "/admin/platform/seckill/activity/switch/".concat(id),
    method: 'POST'
  });
}

/**
 * 秒杀 秒杀商品列表
 */
export function seckillProListApi(params) {
  return request({
    url: "/admin/platform/seckill/product/page",
    method: 'get',
    params: params
  });
}

/**
 * 秒杀 秒杀商品删除
 */
export function seckillProDelApi(data) {
  return request({
    url: "/admin/platform/seckill/product/delete",
    method: 'POST',
    data: data
  });
}

/**
 * 秒杀 秒杀商品设置活动价
 */
export function seckillProSetPriceApi(data) {
  return request({
    url: "/admin/platform/seckill/product/set/price",
    method: 'post',
    data: data
  });
}

/**
 * 秒杀 秒杀商品下架
 */
export function seckillProDownApi(data) {
  return request({
    url: "/admin/platform/seckill/product/down",
    method: 'post',
    data: data
  });
}

/**
 * 秒杀 秒杀商品审核
 */
export function seckillProAuditApi(data) {
  return request({
    url: "/admin/platform/seckill/product/audit",
    method: 'post',
    data: data
  });
}
/**
 * @description 氛围图 -- 选择商品列表 氛围图、活动边框公用同一接口，type传值判断
 */
export function selectProductList(data) {
  return request.get("marketing/spu/lst", data);
}
/**
 * @description 氛围图 -- 创建氛围图
 */
export function createAtuosphere(data) {
  return request.post("admin/platform/activitystyle/save", data);
}
/**
 * @description 氛围图 -- 编辑氛围图
 */
export function atuosphereUpdateApi(data) {
  return request.post("admin/platform/activitystyle/update", data);
}
/**
 * @description 活动样式
 */
export function atuosphereList(params) {
  return request({
    url: "/admin/platform/activitystyle/list",
    method: 'get',
    params: params
  });
}
/**
 * @description 活动样式
 */
export function atmosphereStatusApi(data) {
  return request({
    url: "/admin/platform/activitystyle/status",
    method: 'post',
    data: data
  });
}
/**
 * @description 活动样式
 */
export function atmosphereDelete(params) {
  return request({
    url: "/admin/platform/activitystyle/delete",
    method: 'get',
    params: params
  });
}
/**
 * @description 秒杀商品添加
 */
export function seckillProAdd(data) {
  return request({
    url: "/admin/platform/seckill/product/add",
    method: 'POST',
    data: data
  });
}

/**
 * @description 直播-商品-删除
 */
export function liveGoodsDelApi(id) {
  return request({
    url: "/admin/platform/mp/live/goods/delete/".concat(id),
    method: 'get'
  });
}

/**
 * @description 直播-商品-详情
 */
export function liveGoodsInfoApi(id) {
  return request({
    url: "/admin/platform/mp/live/goods/info/".concat(id),
    method: 'get'
  });
}

/**
 * @description 直播-商品-分页列表
 */
export function liveGoodsListApi(params) {
  return request({
    url: "/admin/platform/mp/live/goods/list",
    method: 'get',
    params: params
  });
}

/**
 * @description 直播-商品-平台审核
 */
export function liveGoodsReviewApi(data) {
  return request({
    url: "/admin/platform/mp/live/goods/review",
    method: 'POST',
    data: data
  });
}

/**
 * @description 直播-商品-修改排序
 */
export function liveGoodsSortApi(id, sort) {
  return request({
    url: "/admin/platform/mp/live/goods/sort/".concat(id, "/").concat(sort),
    method: 'GET'
  });
}

/**
 * @description 直播-直播间 列表
 */
export function liveRoomListApi(data) {
  return request({
    url: "/admin/platform/mp/live/room/list",
    method: 'post',
    data: {
      pageParamRequest: {
        limit: data.limit,
        page: data.page
      },
      searchRequest: {
        reviewStatus: data.reviewStatus,
        liveStatus: data.liveStatus,
        keywords: data.keywords,
        storeShow: data.storeShow,
        merType: data.merType,
        star: data.star
      }
    }
  });
}

/**
 * 直播 直播间 删除直播室
 */
export function liveRoomDeleteApi(roomId) {
  return request({
    url: "/admin/platform/mp/live/room/delete/".concat(roomId),
    method: 'GET'
  });
}

/**
 * 直播 小助手 分页列表
 */
export function liveAssistantListApi(params) {
  return request({
    url: "/admin/merchant/mp/live/assistant/list",
    method: 'get',
    params: params
  });
}

/**
 * 直播 直播间 导入商品
 */
export function liveRoomAddgoodsApi(data) {
  return request({
    url: "/admin/merchant/mp/live/room/addgoods",
    method: 'POST',
    data: data
  });
}

/**
 * 直播 直播间 商品排序
 */
export function liveRoomGoodsortApi(data) {
  return request({
    url: "/admin/platform/mp/live/room/goodsort",
    method: 'post',
    data: data
  });
}

/**
 * 直播 直播间 关闭评论
 */
export function liveRoomUpdatecommentApi(id, banComment) {
  return request({
    url: "/admin/platform/mp/live/room/updatecomment/".concat(id, "/").concat(banComment),
    method: 'get'
  });
}

/**
 * 直播 直播间 获取直播间分享二维码
 */
export function liveRoomGetsharecodeApi(roomId) {
  return request({
    url: "/admin/merchant/mp/live/room/getsharecode/".concat(roomId),
    method: 'get'
  });
}

/**
 * 直播 直播间 直播间商品列表
 */
export function liveRoomGetassApi(id) {
  return request({
    url: "/admin/merchant/mp/live/room/getass/".concat(id),
    method: 'get'
  });
}

/**
 * 直播 直播间 管理直播间小助手
 */
export function liveRoomMangerassApi(data) {
  return request({
    url: "/admin/merchant/mp/live/room/mangerass",
    method: 'post',
    data: data
  });
}

/**
 * 直播 直播间 客服管理
 */
export function liveRoomUpdateclosekfApi(id, closeKf) {
  return request({
    url: "/admin/merchant/mp/live/room/updateclosekf/".concat(id, "/").concat(closeKf),
    method: 'get'
  });
}

/**
 * 直播 直播间 客服管理
 */
export function liveRoomUpdatefeedpublicApi(id, closeKf) {
  return request({
    url: "/admin/platform/mp/live/room/updatefeedpublic/".concat(id, "/").concat(closeKf),
    method: 'get'
  });
}

/**
 * 直播 直播间 官方收录管理
 */
export function liveRoomIsFeedsPublicApi(id, isFeedsPublic) {
  return request({
    url: "/admin/platform/mp/live/room/updatefeedpublic/".concat(id, "/").concat(isFeedsPublic),
    method: 'get'
  });
}

/**
 * 直播 直播间 开启回放
 */
export function liveRoomUpdatereplayApi(id, closeReplay) {
  return request({
    url: "/admin/platform/mp/live/room/updatereplay/".concat(id, "/").concat(closeReplay),
    method: 'get'
  });
}

/**
 * 直播 直播间 直播间商品列表
 */
export function liveRoomGoodsListApi(id) {
  return request({
    url: "/admin/platform/mp/live/room/goodslist/".concat(id),
    method: 'get'
  });
}

/**
 * 直播 直播间 直播室审核
 */
export function liveRoomReviewApi(data) {
  return request({
    url: "/admin/platform/mp/live/room/review",
    method: 'post',
    data: data
  });
}

/**
 * 直播 直播间 显示在商城
 */
export function liveRoomShowApi(id, show) {
  return request({
    url: "/admin/platform/mp/live/room/showstore/".concat(id, "/").concat(show),
    method: 'get'
  });
}

/**
 * 直播 直播间 素材上传本地
 */
export function liveMediaUploadlocalApi(data) {
  return request({
    url: "/admin/merchant/mp/media/uploadlocal",
    method: 'post',
    data: data
  });
}

/**
 * 直播 直播间 创建直播室
 */
export function liveRoomCreateApi(data) {
  return request({
    url: "/admin/merchant/mp/live/room/create",
    method: 'POST',
    data: data
  });
}

/**
 * 直播 直播间 直播间商品列表
 */
export function liveRoomInfoApi(id) {
  return request({
    url: "/admin/merchant/mp/live/room/info/".concat(id),
    method: 'get'
  });
}

/**
 * 直播 直播间 商品上下架
 */
export function liveRoomGoodsonsaleApi(data) {
  return request({
    url: "/admin/merchant/mp/live/room/goodsonsale",
    method: 'post',
    data: data
  });
}

/**
 * 直播 直播间 删除直播间商品
 */
export function liveRoomDeletegoodsinroomApi(roomId, goodsId) {
  return request({
    url: "/admin/merchant/mp/live/room/deletegoodsinroom/".concat(roomId, "/").concat(goodsId),
    method: 'GET'
  });
}

/**
 * 直播 直播间 编辑直播室
 */
export function liveRoomEditApi(data) {
  return request({
    url: "/admin/merchant/mp/live/room/edit",
    method: 'POST',
    data: data
  });
}

/**
 * 直播 小助手 新增
 */
export function liveAssistantSaveApi(data) {
  return request({
    url: "/admin/merchant/mp/live/assistant/save",
    method: 'POST',
    data: data
  });
}

/**
 * 直播 小助手 修改
 */
export function liveAssistantUpdateApi(data) {
  return request({
    url: "/admin/merchant/mp/live/assistant/update",
    method: 'POST',
    data: data
  });
}

/**
 * 直播 小助手 删除
 */
export function liveAssistantDelApi(id) {
  return request({
    url: "/admin/merchant/mp/live/assistant/delete/".concat(id),
    method: 'get'
  });
}

/**
 * 直播 商品 新增并提审
 */
export function liveGoodsSaveApi(data) {
  return request({
    url: "/admin/merchant/mp/live/goods/save",
    method: 'POST',
    data: data
  });
}

/**
 * 直播 商品 修改
 */
export function liveGoodsuUpdateApi(data) {
  return request({
    url: "/admin/merchant/mp/live/goods/update",
    method: 'POST',
    data: data
  });
}

/**
 * 直推活动添加
 */
export function agentactivityscoreadd(data) {
  return request({
    url: "/admin/agent/activity/score/add",
    method: 'POST',
    data: data
  });
}

/**
 * 直推活动列表
 */
export function agentactivityscorepage() {
  return request({
    url: "/admin/agent/activity/score/page",
    method: 'get'
  });
}

/**
 * 直推活动编辑
 */
export function agentactivityscoresedit(data) {
  return request({
    url: "/admin/agent/activity/score/edit",
    method: 'POST',
    data: data
  });
}

/**
 * 直推活动商品列表新增
 */
export function agentactivityscoresgoodsadd(data) {
  return request({
    url: "/admin/agent/activity/score/goods/add",
    method: 'POST',
    data: data
  });
}

/**
 * 直推活动商品列表
 */
export function agentactivityscoregoodspage(params) {
  return request({
    url: "/admin/agent/activity/score/goods/page",
    method: 'get',
    params: params
  });
}
/**
 * 直推活动编辑
 */
export function agentactivityscoregoodsedit(data) {
  return request({
    url: "/admin/agent/activity/score/goods/edit",
    method: 'POST',
    data: data
  });
}
/**
 * 直推活动商品列表删除
 */
export function agentactivityscoregoodsedelete(id) {
  return request({
    url: "/admin/agent/activity/score/goods/delete/".concat(id),
    method: 'POST'
  });
}
/**
 * 直推活动列表删除
 */
export function agentactivityscoredelete(id) {
  return request({
    url: "/admin/agent/activity/score/delete/".concat(id),
    method: 'POST'
  });
}

/**
 * 直推活动获奖记录列表
 */
export function agentactivityscoreclearingpage(params) {
  return request({
    url: "/admin/agent/activity/score/clearing/list",
    method: 'get',
    params: params
  });
}
/**
 * 直推活动获奖记录下拉项
 */
export function agentactivityscorectree(params) {
  return request({
    url: "/admin/agent/activity/score/tree",
    method: 'get',
    params: params
  });
}

/**
 * 直推活动获奖记录结算
 */
export function agentactivityscoreclearing(id) {
  return request({
    url: "/admin/agent/activity/score/clearing/clearing/".concat(id),
    method: 'POST'
  });
}

/**
 * 直推活动获奖记录删除
 */
export function agentactivityscoreclearingdelete(id) {
  return request({
    url: "/admin/agent/activity/score/clearing/delete/".concat(id),
    method: 'POST'
  });
}

/**
 * 直推活动获奖记录积分确认
 */
export function agentactivityscoreclearingverify(id) {
  return request({
    url: "/admin/agent/activity/score/clearing/verify/".concat(id),
    method: 'POST'
  });
}

/**
 * 直推活动编辑
 */
export function agentactivityscoreclearingedit(data) {
  return request({
    url: "/admin/agent/activity/score/clearing/edit",
    method: 'POST',
    data: data
  });
}

/**
 * 直推活动获奖记录删除的下拉项
 */
export function agentactivityscorecdeltree(params) {
  return request({
    url: "/admin/agent/activity/score/del/tree",
    method: 'get',
    params: params
  });
}

/**
 * 抽奖活动列表
 */
export function agentlotterypage(params) {
  return request({
    url: "/admin/agent/lottery/page",
    method: 'get',
    params: params
  });
}

/**
 * 抽奖活动开启关闭
 */
export function agentlotteryswitch(id) {
  return request({
    url: "/admin/agent/lottery/switch/".concat(id),
    method: 'POST'
  });
}

/**
 * 抽奖活动新增
 */
export function agentlotteryadd(data) {
  return request({
    url: "/admin/agent/lottery/add",
    method: 'POST',
    data: data
  });
}
/**
 * 抽奖活动删除
 */
export function agentlotterydelete(id) {
  return request({
    url: "/admin/agent/lottery/delete/".concat(id),
    method: 'POST'
  });
}
/**
 * 抽奖活动编辑
 */
export function agentlotteryedit(data) {
  return request({
    url: "/admin/agent/lottery/edit",
    method: 'POST',
    data: data
  });
}

/**
 * 抽奖活动详情
 */
export function agentlotterydetail(id) {
  return request({
    url: "/admin/agent/lottery/detail/".concat(id),
    method: 'POST'
  });
}
/**
 * 抽奖活动 编辑商品列表
 */
export function agentlotteryprizelist(id) {
  return request({
    url: "/admin/agent/lottery/prize/list/".concat(id),
    method: 'POST'
  });
}

/**
 * 抽奖活动中奖记录列表
 */
export function agentlotteryrecordpage(params) {
  return request({
    url: "/admin/agent/lottery/record/page",
    method: 'get',
    params: params
  });
}
/**
 * 抽奖活动中奖记录备注
 */
export function agentlotteryrecordremark(data) {
  return request({
    url: "/admin/agent/lottery/record/remark",
    method: 'POST',
    data: data
  });
}

/**
 * 抽奖活动中奖记录列表导出
 */
export function agentlotteryrecordexcel(params) {
  return request({
    url: "/admin/agent/lottery/record/excel",
    method: 'get',
    params: params
  });
}

/**
 * 排行榜列表
 */
export function agentrankingypage(params) {
  return request({
    url: "/admin/agent/ranking/page",
    method: 'get',
    params: params
  });
}

/**
 * 排行榜开启
 */
export function agentrankingswitch(id) {
  return request({
    url: "/admin/agent/ranking/switch/".concat(id),
    method: 'POST'
  });
}
/**
 * 排行榜删除
 */
export function agentrankingdelete(id) {
  return request({
    url: "/admin/agent/ranking/delete/".concat(id),
    method: 'POST'
  });
}

/**
 * 抽奖活动新增
 */
export function agentrankingadd(data) {
  return request({
    url: "/admin/agent/ranking/add",
    method: 'POST',
    data: data
  });
}

/**
 * 直推活动商品列表
 */
export function agentrankinggoodspage(params) {
  return request({
    url: "/admin/agent/ranking/goods/page",
    method: 'get',
    params: params
  });
}
/**
 * 直推活动商品列表新增
 */
export function agentrankinggoodsadd(data) {
  return request({
    url: "/admin/agent/ranking/goods/add",
    method: 'POST',
    data: data
  });
}
/**
 * 直推活动商品列表编辑
 */
export function agentrankinggoodsEdit(data) {
  return request({
    url: "/admin/agent/ranking/goods/edit",
    method: 'POST',
    data: data
  });
}
/**
 * 排行榜活动详情
 */
export function agentrinkingdetail(id) {
  return request({
    url: "/admin/agent/ranking/detail/".concat(id),
    method: 'POST'
  });
}

/**
 * 直推活动编辑
 */
export function agentrinkingsedit(data) {
  return request({
    url: "/admin/agent/ranking/edit",
    method: 'POST',
    data: data
  });
}
/**
 * 排行榜活动商品列表删除
 */
export function agentrinkinggoodsedelete(id) {
  return request({
    url: "/admin/agent/ranking/goods/delete/".concat(id),
    method: 'POST'
  });
}

/**
 * 直推活动商品列表
 */
export function agentrankingInfoList(id) {
  return request({
    url: "/admin/agent/ranking/rankinginfo?id=" + id,
    method: 'get'
  });
}
/**
 * 会场类型列表
 */
export function meetingTypeList(data) {
  return request({
    url: "/admin/platform/meetingType/pageList",
    method: 'get',
    data: data
  });
}
/**
 * 会场明细列表
 */
export function meetingRecordList(params) {
  return request({
    url: "/admin/platform/meetingUser/pageList",
    method: 'get',
    params: params
  });
}
/**
 * 会场明细列表导出
 */
export function exportMeetingRecordList(params) {
  return request({
    url: "/admin/platform/export/meting/meetingUser/excel",
    method: 'get',
    params: params
  });
}
/**
 * 会员贡献值明细列表导出
 */
export function exportMeetingContributionFlowList(params) {
  return request({
    url: "/admin/platform/export/meting/meetingContributionFlow/excel",
    method: 'get',
    params: params
  });
}
/**
 * 会员贡献值明细列表
 */
export function meetingContributionFlowList(params) {
  return request({
    url: "/admin/platform/meetingContributionFlow/pageList",
    method: 'get',
    params: params
  });
}
/**
 * 新增会场类型
 */
export function addMeetingType(data) {
  return request({
    url: "/admin/platform/meetingType/add",
    method: 'post',
    data: data
  });
}
/**
 * 修改会场类型
 */
export function updateMeetingType(data) {
  return request({
    url: "/admin/platform/meetingType/update",
    method: 'post',
    data: data
  });
}

/**
 * 订单权益活动配置
 */
export function orderPromotionConfigList(params) {
  return request({
    url: "/admin/platform/order/promotion/config/list",
    method: 'get',
    params: params
  });
}

/**
 * 订单权益活动配置详情
 */
export function orderPromotionConfigDetail(id) {
  return request({
    url: "/admin/platform/order/promotion/config/info/".concat(id),
    method: 'get'
  });
}

/**
 * 订单权益活动配置新增
 */
export function orderPromotionConfigAdd(data) {
  return request({
    url: "/admin/platform/order/promotion/config/save",
    method: 'post',
    data: data
  });
}
/**
 * 订单权益活动配置修改
 */
export function orderPromotionConfigUpdate(data) {
  return request({
    url: "/admin/platform/order/promotion/config/update",
    method: 'post',
    data: data
  });
}
/**
 * 订单权益活动配置开启
 */
export function orderPromotionConfigOpen(id) {
  return request({
    url: "/admin/platform/order/promotion/config/open/".concat(id),
    method: 'post'
  });
}
/**
 * 订单权益活动配置关闭
 */
export function orderPromotionConfigClose(id) {
  return request({
    url: "/admin/platform/order/promotion/config/close/".concat(id),
    method: 'post'
  });
}
/**
 * 订单权益活动配置删除
 */
export function orderPromotionConfigDelete(id) {
  return request({
    url: "/admin/platform/order/promotion/config/delete/".concat(id),
    method: 'post'
  });
}

// 演唱会管理
export function getConcertRecordList(params) {
  return request({
    url: "/admin/user-choice/records",
    method: 'get',
    params: params
  });
}
// 活动可选用户标签
export function getUserChoiceTagList() {
  return request({
    url: "/admin/user-choice/user-tags",
    method: 'get'
  });
}
// 活动列表
export function getActivityList(params) {
  return request({
    url: "/admin/user-choice/activities",
    method: 'get',
    params: params
  });
}
// 活动列表详情
export function getActivityDetail(id) {
  return request({
    url: "/admin/user-choice/activities/".concat(id),
    method: 'get'
  });
}

// 创建活动
export function createActivity(data) {
  return request({
    url: "/admin/user-choice/activities",
    method: 'post',
    data: data
  });
}
// 修改活动
export function updateActivity(id, data) {
  return request({
    url: "/admin/user-choice/activities/".concat(id),
    method: 'PUT',
    data: data
  });
}

// 删除活动
export function deleteActivity(id) {
  return request({
    url: "/admin/user-choice/activities/".concat(id),
    method: 'delete'
  });
}